import { Routes } from '@angular/router';
import { JobListComponent } from './components/job-list/job-list.component';
import { JobDetailComponent } from './components/job-detail/job-detail.component';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ProfileLayoutComponent } from './layouts/profile-layout/profile-layout.component';
import { LoginComponent } from './components/auth/login/login.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { LanguageGuard } from './guards/language.guard';
import { JobApplyComponent } from './components/job-apply/job-apply.component';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { JobsPageComponent } from './pages/jobs-page/jobs-page.component';
import { SettingsPageComponent } from './pages/settings-page/settings-page.component';
import { MarketAnalyticsPageComponent } from './pages/market-analytics-page/market-analytics-page.component';
import { CompaniesPageComponent } from './pages/companies-page/companies-page.component';
import { MarketPredictionsPageComponent } from './pages/market-predictions-page/market-predictions-page.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  // Simple root route for testing
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [{ path: '', component: JobListComponent }],
  },
  // Routes with language prefix
  {
    path: ':lang',
    canActivate: [LanguageGuard],
    children: [
      // Auth routes with language prefix
      {
        path: 'login',
        component: AuthLayoutComponent,
        children: [{ path: '', component: LoginComponent }],
      },
      {
        path: 'register',
        component: AuthLayoutComponent,
        children: [{ path: '', component: RegisterComponent }],
      },
      {
        path: 'forgot-password',
        component: AuthLayoutComponent,
        children: [{ path: '', component: ForgotPasswordComponent }],
      },
      {
        path: 'passwordReset',
        component: AuthLayoutComponent,
        children: [{ path: '', component: ResetPasswordComponent }],
      },
      // Default layout routes with language prefix
      {
        path: '',
        component: DefaultLayoutComponent,
        children: [
          { path: '', component: JobListComponent },
          { path: 'job/:id', component: JobDetailComponent },
          { path: 'job/:id/apply', component: JobApplyComponent },
          { path: 'companies', component: CompaniesPageComponent },
          { path: 'market-analytics', component: MarketAnalyticsPageComponent },
          { path: 'market-predictions', component: MarketPredictionsPageComponent },
          {
            path: 'privacy-policy',
            loadComponent: () => import('./pages/legal-wrapper/privacy-policy-wrapper.component').then((m) => m.PrivacyPolicyWrapperComponent),
          },
          {
            path: 'terms-of-use',
            loadComponent: () => import('./pages/legal-wrapper/terms-of-use-wrapper.component').then((m) => m.TermsOfUseWrapperComponent),
          },
          {
            path: 'subprocessors',
            loadComponent: () => import('./pages/legal-wrapper/subprocessors-wrapper.component').then((m) => m.SubprocessorsWrapperComponent),
          },
        ],
      },
      // Profile layout routes with language prefix
      {
        path: '',
        component: ProfileLayoutComponent,
        canActivate: [authGuard],
        children: [
          { path: 'profile', component: ProfilePageComponent },
          { path: 'jobs', component: JobsPageComponent },
          { path: 'settings', component: SettingsPageComponent },
        ],
      },
    ],
  },
  // Routes without language prefix (fallback) - redirect to default language routes
  {
    path: 'login',
    component: AuthLayoutComponent,
    canActivate: [LanguageGuard],
    children: [{ path: '', component: LoginComponent }],
  },
  {
    path: 'register',
    component: AuthLayoutComponent,
    canActivate: [LanguageGuard],
    children: [{ path: '', component: RegisterComponent }],
  },
  {
    path: 'forgot-password',
    component: AuthLayoutComponent,
    canActivate: [LanguageGuard],
    children: [{ path: '', component: ForgotPasswordComponent }],
  },
  {
    path: 'passwordReset',
    component: AuthLayoutComponent,
    canActivate: [LanguageGuard],
    children: [{ path: '', component: ResetPasswordComponent }],
  },
  { path: '**', redirectTo: '/en' },
];
